const truncateText = (text, maxLength) => {
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
}

// Objekt for å holde beskrivelse for å enkelt bytte mellom
const descObject = {
  original: "",
  truncated: "",
};

// Definer hvor mange karakterer før teksten kuttes av
const MAX_LENGTH = 200;

let isOpen = false;

document.addEventListener("DOMContentLoaded", function() {
  const description = document.querySelector('#collection-description');
  descObject.original = description.getAttribute('data-description');

  descObject.truncated = truncateText(descObject.original, MAX_LENGTH);

  description.textContent = descObject.truncated;

  const viewMoreBtn = document.querySelector('.btn_show-more');

  viewMoreBtn.addEventListener('click', () => {
    if (!isOpen) {
      isOpen = true;
      description.textContent = descObject.original;
      viewMoreBtn.textContent = 'Se mindre';
    } else {
      isOpen = false;
      description.textContent = descObject.truncated;
      viewMoreBtn.textContent = 'Se mer';
    }
  });
});

//Add all products in collection to cart
// Add all products in collection to cart
document.addEventListener("DOMContentLoaded", function () {
    console.log("Script loaded");

    document.addEventListener("click", async function (event) {
        const bulkAddButton = event.target.closest("#bulk-add-to-cart");
        const bulkAddMessage = document.getElementById("bulk-add-message");

        if (bulkAddButton) {
            console.log("Bulk Add button clicked");

            // Show processing message
            if (bulkAddMessage) {
                bulkAddMessage.style.display = "block";
                bulkAddMessage.innerText = "Et øyeblikk, varene legges til handlekurv...";
            }

            // Disable the button to prevent multiple clicks
            bulkAddButton.disabled = true;
            bulkAddButton.style.opacity = "0.6";
            bulkAddButton.innerText = "Legger til...";

            // Get all product cards
            const productCards = document.querySelectorAll("product-card");
            const products = [];

            productCards.forEach((card) => {
                const variantId = card.getAttribute("data-variant-id");
                if (variantId) {
                    products.push({ id: variantId, quantity: 1 });
                }
            });

            console.log("Products to add:", products);

            if (products.length > 0) {
                await addProductsToCartSequentially(products); // Wait for process to complete
            } else {
                alert("No products found to add.");
            }

            // Re-enable button and hide message after process completes
            bulkAddButton.disabled = false;
            bulkAddButton.style.opacity = "1";
            bulkAddButton.innerText = "Legg alt i handlekurven";

            if (bulkAddMessage) {
                bulkAddMessage.innerText = "Alle varer er lagt i handlekurven!";
                setTimeout(() => {
                    bulkAddMessage.style.display = "none";
                }, 3000); // Hide message after 3 seconds
            }

            window.location.reload(); // Refresh cart drawer after adding all products
        }
    });

    async function addProductsToCartSequentially(products) {
        console.log("Adding products to cart sequentially:", products);

        for (const product of products) {
            try {
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        id: product.id,
                        quantity: product.quantity,
                    }),
                });

                if (!response.ok) {
                    console.error("Failed to add product:", product, response.statusText);
                } else {
                    console.log("Successfully added product:", product);
                }
            } catch (error) {
                console.error("Error adding product to cart:", product, error);
            }
        }
    }
});

//Add all products in collection to cart end

/* Cookie first banner - link in privacy policy */

  function initCookieSettingsLink() {
    const link = document.getElementById('cookie-settings');
    if (!link) return;
    link.removeEventListener('click', openCookiePanel);
    link.addEventListener('click', openCookiePanel);
  }

  function openCookiePanel(e) {
    e.preventDefault();
    if (window.CookieFirst && typeof CookieFirst.openPanel === 'function') {
      CookieFirst.openPanel();
    }
  }

  // 1) if CF API loads first
  window.addEventListener('cf_init', initCookieSettingsLink);
  // 2) if DOM loads (and you’ve already consented so cf_init won’t fire again)
  document.addEventListener('DOMContentLoaded', initCookieSettingsLink);
